import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';

@Component({
  selector: 'bms-common-popup',
  templateUrl: './bms-common-popup.component.html',
  styleUrls: ['./bms-common-popup.component.scss'],
})
export class BMSCommonPopupComponent implements OnChanges {
  // For Title Section
  @Input() icon: string;
  @Input() title: string;
  @Input() subTitle: string;

  // For Footer
  @Input() cancelTitle: string;
  @Input() isCancelEnabled = true;
  @Input() submitTitle: string;
  @Input() isSubmitEnabled = false;
  @Input() hideFooter = false;
  @Input() secondarySubmitTitle: string = '';
  @Input() isSecondarySubmitEnabled = true;

  @Output() onCancelClick: EventEmitter<boolean> = new EventEmitter();
  @Output() onSubmitClick: EventEmitter<boolean> = new EventEmitter();
  @Output() onSecondarySubmitClick: EventEmitter<boolean> = new EventEmitter();

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.isSubmitEnabled) {
      this.isSubmitEnabled = changes.isSubmitEnabled.currentValue;
    }
  }

  onClickCancel(val: boolean) {
    this.onCancelClick.emit(val);
  }

  onClickSubmit(val: boolean) {
    this.onSubmitClick.emit(val);
  }

  onClickSecondarySubmit(val: boolean) {
    this.onSecondarySubmitClick.emit(val);
  }
}
